export const environment = {
  production: false,
  domain: 'https://dev-web.scanafy.de',
  apiUrl: 'https://dev-api.scanafy.de/api',
  apiAuthUrl: 'https://dev-api.scanafy.de/api/auth'
};
